import React, { useEffect, useState } from 'react';

const COOKIE_KEY = 'halr_cookie_consent_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(COOKIE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('cookie-banner-open', visible);
    return () => document.documentElement.classList.remove('cookie-banner-open');
  }, [visible]);

  const accept = () => {
    try { localStorage.setItem(COOKIE_KEY, JSON.stringify({ essential: true, analytics: true, ts: Date.now() })); } catch {}
    window.dispatchEvent(new Event('halr-cookie-consent'));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50" data-testid="cookie-banner">
      <div className="pointer-events-auto mx-auto max-w-5xl m-4 max-lg:m-3 max-lg:mb-[max(0.75rem,env(safe-area-inset-bottom))] p-4 max-lg:p-3 rounded-lg bg-neutral-90 text-white shadow-lg border border-white/10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-sm md:text-base max-lg:text-[13px] max-lg:leading-snug">
            We use cookies to operate the app and improve performance. See our <a className="underline text-accent-lime" href="/legal/cookies">Cookie Notice</a>.
          </div>
          <div className="flex items-center gap-3 max-lg:w-full">
            <a href="/legal/cookies" className="px-3 py-2 max-lg:min-h-11 max-lg:flex-1 max-lg:inline-flex max-lg:items-center max-lg:justify-center text-sm rounded-lg bg-white/10 hover:bg-white/20 border border-white/20">Manage</a>
            <button type="button" data-testid="cookie-accept" onClick={accept} className="px-4 py-2 max-lg:min-h-11 max-lg:flex-1 max-lg:inline-flex max-lg:items-center max-lg:justify-center text-sm rounded-lg bg-accent-lime text-primary-50 hover:bg-accent-lime/90">Accept</button>
          </div>
        </div>
      </div>
    </div>
  );
}
